import template from './template.html'
import Controller from './controller'

export default {
  template,
  controller: Controller,
  controllerAs: 'vm',
  bindings: {
    config: '=',
    runSearch: '&',
    resetFilters: '&',
    onAutocomplete: '&',
  },
}
